import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueTruncate from 'vue-truncate-filter'
import SocialSharing from 'vue-social-sharing'


import Page from './views/page.vue'
import Main from './views/main.vue'
import Contacts from './views/contacts.vue'
import Posts from './views/posts.vue'
import Single from './views/single-post.vue'
import Sidebar from './views/sidebar.vue'
import Photos from './views/photo-report.vue'
import SinglePhoto from './views/single-photo.vue'

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueTruncate)
Vue.use(SocialSharing)

Vue.component('sidebar', Sidebar)

var router = new VueRouter({

	routes: [
		{
			path: '/page/:id', name: 'post', component: Page, props: true
		},
		{
			path: '*', component: Main,
		},
		{
			path: '/posts', name: 'all-post', component: Posts
		},
		{
			path: '/posts/:id', name: 'single-post', component: Single, props: true
		},
		{
			path: '/photoalbums', component: Photos, props: true
		},
		{
			path: '/photoalbums/:id', component: SinglePhoto, props: true
		}
	]
})

Vue.filter('striphtml', function (value) {
	var div = document.createElement("div");
	div.innerHTML = value;
	var text = div.textContent || div.innerText || "";
	return text;
})

new Vue({
	el: '#main',
	router: router,
	delimiters: ['[[', ']]'],

	data: {
		main: 'https://dnz-kalynka.pp.ua/api/get_menu/',
		menu: []
	},
	methods: {
		mainMenu: function(){
			this.$http.get(this.main).then(function(response){
				this.menu = response.data
				// console.log(response)
			}, function(error){
				console.log('Помилка при отриманні даних')
				// console.log(this.$route.path)
			})
		}
	},
	created: function(){
		this.mainMenu()
	}
})



// WEBPACK FOOTER //
// ./src/main.js